function getExportApi() {
    const origin = typeof location === 'undefined' ? '' : location.origin
    if (origin.indexOf('localhost') !== -1) {
        return origin + '/'
    }
    if (origin.indexOf('parteco.cn') !== -1) {
        return '//warehouse-apply.parteco.cn/'
    }
    if (origin.indexOf('qp11.cn') !== -1) {
        return '//qp11.cn/'
    }
    return origin ? (origin + '/') : process.env.baseURL
}

export const config = {
    API: process.env.baseURL,
    // 导出接口域名
    EXPORT_API: getExportApi(),
    QXB_WEB: process.env.QXB_WEB,
    QXB_API: process.env.QXB_API,
    PTD_API: process.env.PTD_API,
    CCJ_API: process.env.CCJ_API,
    DATA_API: process.env.DATA_API,
    APPID: process.env.APPID,
    BAIDU_AK: process.env.BAIDU_AK,
	JDAPP_KEY: process.env.JDAPP_KEY,
    // 当前版本
    VERSION: '1.0.0',
    // 是否显示公告
    SHOW_NOTICE: true
}


//////////////////
// WEBPACK FOOTER
// ./config/network.js
// module id = 85
// module chunks = 116